import { paths as userPaths, profilePath } from '../Users/paths';
import { paths as permGroupPaths } from '../PermissionGroups/paths';

export const paths = [...userPaths, ...permGroupPaths, profilePath];
